// Admin cost-calculator config API client.
//
// Backed by:
//   GET  /api/admin/calculator-config  → current pricing config
//   PUT  /api/admin/calculator-config  → persist a new config (bumps version)
import type { CalculatorConfig } from "@interioring/utils/calculator";
import { request } from "../base";

export const adminCalculatorConfigApi = {
	async getCalculatorConfig() {
		return request<CalculatorConfig>(`/api/admin/calculator-config`);
	},

	async updateCalculatorConfig(config: CalculatorConfig) {
		return request<CalculatorConfig>(`/api/admin/calculator-config`, {
			method: "PUT",
			body: config,
		});
	},
};
